<template>
  <transition
    name="project__transition"
    mode="out-in"
    appear
  >
    <div class="project">
      <div class="project__header">
        <h5>Add to Project</h5>

        <div class="project__close">
          <UtilityIconButton
            size="md"
            variant="round"
            backgroundColor="#12130f"
            highlightColor="rgba(255,255,255,0.7)"
            highlightBackgroundColor="#070806"
            content="Close"
            v-tippy="{ theme: 'statzon', placement: 'left', arrow: true, animation: 'scale' }"
            @click.native="close()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/></svg>
          </UtilityIconButton>
        </div>
      </div>
      <div class="row row--separator row--border">
        <div class="row__full">
          <FormSelect
            v-model="selectedProject"
            :options="projects"
            :icon="icon"
            dropdownHeight="136px"
            placeholder="Project"
            :label="'Select Project to add this ' + (this.selectedDocument.type === 'datasets' ? 'Dataset' : (this.selectedDocument.type === 'pdfs' ? 'Report' : 'Document')) + ' to'"
            :alt-label="'Select Project to add this ' + (this.selectedDocument.type === 'datasets' ? 'Dataset' : (this.selectedDocument.type === 'pdfs' ? 'Report' : 'Document')) + ' to'"
          />
        </div>
      </div>
      <div
        v-if="selectedProject && selectedProject.key === 'new'"
        class="row row--separator"
      >
        <div class="row__full">
          <FormInput
            :value="projectName"
            :icon="icon"
            type="text"
            refName="project_name"
            placeholder="Bookmarks"
            label="Project name"
            alt-label="Project name"
            size="md"
            variant="dark"
            iconSize="md"
            style="margin-top: 10;"
            @inputChanged="setFieldValue($event, 'projectName')"
          />
        </div>
      </div>
      <div
        v-if="selectedProject && selectedProject.key === 'new'"
        class="row row--border"
      >
        <div class="row__full">
          <FormTextarea
            v-model="projectNotes"
            type="text"
            refName="project_notes"
            placeholder="..."
            label="Project notes (HTML is supported)"
            alt-label="Project notes (HTML is supported)"
            size="md"
            variant="dark"
            iconSize="md"
          />
        </div>
      </div>
      <div class="row row--separator">
        <div class="row__full row__center">
          <FormSubmit
            :status="formStatus"
            :disabled="selectedProject[selectedDocument.type] && selectedProject[selectedDocument.type].indexOf(selectedDocument.id) !== -1"
            variant="blue"
            :icon="icon"
            @click="addToProject()"
          >
            {{ selectedProject[selectedDocument.type] && selectedProject[selectedDocument.type].indexOf(selectedDocument.id) !== -1 ? 'Already added to this project' : (formStatus === 'loading' ? 'Adding...' : 'Add to project') }}
          </FormSubmit>
        </div>
      </div>
      <div class="row" />
    </div>
  </transition>
</template>

<script>
import FormSubmit from '@/components/form/Submit.vue'
import UtilityIconButton from '@/components/utility/IconButton.vue'
import FormInput from '@/components/form/Input.vue'
import FormSelect from '@/components/form/Select.vue'
import FormTextarea from '@/components/form/Textarea.vue'
import helperMethods from '@/helpers/utility'

export default {
  components: {
    FormSubmit,
    UtilityIconButton,
    FormInput,
    FormSelect,
    FormTextarea
  },
  data () {
    return {
      selectedProject: '',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M11 5c-1.629 0-2.305-1.058-4-3h-7v20h24v-17h-13zm3.599 12l-2.599-1.39-2.599 1.39.518-2.902-2.125-2.042 2.921-.404 1.285-2.652 1.285 2.652 2.921.404-2.125 2.042.518 2.902z"/></svg>',
      errorMessage: '',
      projectName: '',
      projectNotes: '',
      formStatus: 'default',
      documents: {}
    }
  },
  computed: {
    projects () {
      let userProjects = [];
      let projectsObj = this.$store.getters['user/getProjects'].byId
      Object.keys(projectsObj).forEach(element => {
        let datasets = []
        let pdfs = []

        projectsObj[element].attributes.documents.forEach(document => {
          if (document.attributes.resource_type === 'datasets') {
            datasets.push(document.attributes.resource_id)
          } else if (document.attributes.resource_type === 'pdfs') {
            pdfs.push(document.attributes.resource_id)
          }
        })

        userProjects.push({
          key: projectsObj[element].id,
          name: projectsObj[element].attributes.name,
          datasets,
          pdfs
        })

      })
      userProjects.push({
        key: 'new',
        name: 'Add new Project...'
      })
      return userProjects
    },
    selectedDocument () {
      return this.$store.getters['search/getAddingToProject']
    }
  },
  mounted () {
  },
  methods: {
    setFieldValue (value, field) {
      this[field] = value
    },
    close () {
      this.$emit('closed')
    },
    async addToProject () {
      this.errorMessage = ''
      this.formStatus = 'loading'
      let projectId = this.selectedProject.key
      if (projectId === 'new') {
        let newProject = await this.$store.dispatch('user/addProject', { 'name': this.projectName, 'notes': this.projectNotes })
        projectId = newProject.data.id
      }

      let formData = {
        project_id: projectId,
        resource_type: this.selectedDocument.type,
        resource_id: this.selectedDocument.id
      }

      await this.$store.dispatch('user/addProjectDocument', formData)
      await this.$store.dispatch('user/fetchProjects')
      this.formStatus = 'success'
      this.close()
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.project {
  @include font('content--md', $white, 0.9);
  position: absolute;
  top: 0px;
  width: 100%;
  height: auto;
  text-align: center;
  height: auto;
  background-color: $bg-3;
  border: 1px solid $black;

  @media screen and (min-width: $breakpointSm) {
    width: 448px;
  }

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.9);
  }

  &__transition {
    &-enter-active, &-leave-active {
      transition: opacity 0.25s ease-out, transform 0.25s ease-out;
      transform: scale(1);
    }

    &-enter, &-leave-to {
      opacity: 0;
      transform: translateY(-20%) scale(0.6);
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    background-color: $bg-2;
    padding: 8px 12px 8px 16px;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;

    h5 {
      @include font('header--sm');
      text-transform: uppercase;
    }
  }

  &__top {
    display: flex;
    justify-content: space-between;
    padding: 0.4rem 1rem;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;

    &--light {
      color: rgba($white, 0.7);
    }

    &--danger {
      color: $danger;
    }

    &--warning {
      color: $warning;
    }
  }

  &__info {
    margin: 0rem auto;
    padding: 0.75rem 1.5rem 1.25rem 1.5rem;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;
    color: rgba($white, 0.9);

    p {
      margin: 0;
      padding: 0;
    }
  }

  &__form {
    border-top: 1px solid rgba($white, 0.1);
  }

  &__tooltip {
    svg {
      position: relative;
      top: 3px;
      left: 3px;
      width: 18px;
      height: 18px;
      fill: rgba($white, 0.7);

      @media screen and (min-width: $breakpointLg) {
        width: 20px;
        height: 20px;
        top: 4px;
      }

      &:hover {
        fill: rgba($blue, 1);
      }
    }
  }

  &__code {
    width: 100%;
    text-align: left;
    background-color: #12130f;
    padding: 0!important;
    border-radius: 4px;

    &:hover, &:active {
      background-color: #070806;
    } 
  }

  &__chart {
    height: 194px!important;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
  }

  &__preview {
    height: 194px;
    width: 100%;
    text-align: center;
    background-color: rgb(27,30,33);
    border-radius: 4px;
    overflow: hidden;

    h2 {
      margin: 0;
      padding: 16px;
    }
  }

  &__iframe {
    width: calc(100% - 1rem);
    padding: 0.5rem;
  }

  &__typeSelector {
    width: 67%;
    display: inline-block;
    padding-right: 1rem;
  }

  &__yearSelector {
    width: 33%;
    display: inline-block;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: 0.75rem auto;
  padding: 0rem 1rem;

  @media screen and (min-width: $breakpointLg) {
    margin: 1rem auto;
  }

  &--border {
    border-bottom: 1px solid $black;
    margin: 0.75rem auto 0 auto !important;
    padding-bottom: 1rem !important;
  }

  &--separator {
    border-top: 1px solid rgba($white, 0.1);
    padding: calc(1rem - 1px) 1rem 0 1rem;
    margin: 0 !important;

    &Top {
      margin-top: 0.5rem;
    }
  }

  &__full {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;

    &--filters {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
    }

    &--condensed {
      justify-content: space-around;
    }
  }

  &__left {
    flex: 0.2;
    text-align: left;
  }

  &__right {
    flex: 0.8;
    text-align: left;
  }

  &__notice {
    color: rgba($white, 0.5);
    margin: 0 auto 1rem auto;
    display: block;
    font-style: italic;
  }

  &__center {
    margin: 0 auto;
    display: block;
  }

  &__error {
    color: $red;
    margin: 0;
  }

  &__label {
    color: rgba($white, 0.9);
    text-align: left;
  }

  &__operator {
    @include font('content--xs', $white, 0.5);
    position: relative;
    z-index: 9;
    font-weight: 500;
    margin: 0px 3px;
    text-transform: uppercase;
    display: inline-flex;

    /deep/ span {
      color: rgba($white, 0.7) !important;
    }

    &--active {
      color: rgba($white, 0.7);
    }
  }

  &__filter {
    position: relative;
    z-index: 10;
  }
}
</style>
